import { getEnv } from '#env-schema.js';

/**
 * Generate a page title with an optional suffix (ELARA-700/754).
 *
 * Page titles are surfaced by the web router (via `NavigationPort.setPageTitle`), but composing the
 * string is portable logic. The default suffix reads the injected env through `getEnv()` rather than
 * importing the web `Env` singleton (`client/src/env.ts`), so this module compiles under the no-DOM
 * `@elara/client-core` lib and runs on React Native — each platform injects its `Env` at bootstrap
 * via `setEnv()` (ELARA-754).
 *
 * @param title - The main title
 * @param suffix - Optional suffix (defaults to the app name, with a dev marker outside production)
 * @returns Formatted page title
 */
export function generatePageTitle(title: string, suffix = getEnv().MODE === 'development' ? 'Elara Dev' : 'Elara'): string {
  return `${title} - ${suffix}`;
}
